<template>
  <PreGameModal :progress="progress" :progressTotal="progressTotal">
    <template #content>
      <div class="content">
        <Checking v-if="state === State.CHECKING" />
        <Good v-if="state === State.GOOD" @next="$emit('next')" />
        <NoHost v-if="state === State.NO_HOST" @back="$emit('back')" />
        <NonOptimal v-if="state === State.NON_OPTIMAL" @back="$emit('back')" @next="$emit('next')" @restart="restart" />
        <WrongBrowser v-if="state === State.WRONG_BROWSER" @back="$emit('back')" />
        <BadInternet v-if="state === State.BAD_INTERNET" @back="$emit('back')" @restart="restart" />
        <AlreadyPaired v-if="state === State.ALREADY_PAIRED" @back="$emit('back')" />
      </div>
    </template>
  </PreGameModal>
</template>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  align-self: center;
  align-items: center;

  gap: 16px;
}
</style>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';

import PreGameModal from './PreGameModal.vue';

import Checking from './PreGameModalChecks/2.0.Checking.vue';
import Good from './PreGameModalChecks/2.1.Good.vue';
import NonOptimal from './PreGameModalChecks/2.2.NonOptimal.vue';
import NoHost from './PreGameModalChecks/2.3.1.NoHost.vue';
import WrongBrowser from './PreGameModalChecks/2.3.2.WrongBrowser.vue';
import BadInternet from './PreGameModalChecks/2.3.3.BadInternet.vue';
import AlreadyPaired from './PreGameModalChecks/2.3.4.AlreadyPaired.vue';

import { useCompatibilityCheckStore } from "@/stores/compatibilityCheck.js";
import { useCloudClientStore } from "@/stores/cloud-client.js";

const compatibilityCheckStore = useCompatibilityCheckStore();
const cloudClient = useCloudClientStore();

defineProps({
  progress: {
    type: Number,
    required: true,
  },
  progressTotal: {
    type: Number,
    required: true,
  },
});

defineEmits([
  'back',
  'restart',
  'next',
]);

enum State {
  CHECKING,
  GOOD,
  NON_OPTIMAL,
  NO_HOST,
  WRONG_BROWSER,
  BAD_INTERNET,
  ALREADY_PAIRED
}

const state = ref(State.CHECKING);

const { currentStatus, tests, hardwareSpecifications } = storeToRefs(
  compatibilityCheckStore
);

async function launchTests() {
  state.value = State.CHECKING;
  await compatibilityCheckStore.launchTests();
  
  // Send hardware specs to the cloud client
  cloudClient.pushHardwareSpecs(hardwareSpecifications.value);

  if (tests.value[4].result.name === "error" && tests.value[4].result.message !== "Session en cours") state.value = State.NO_HOST;
  else if (tests.value[4].result.name === "error" && tests.value[4].result.message === "Session en cours") state.value = State.ALREADY_PAIRED;
  else if (tests.value[1].result.name === "error") state.value = State.WRONG_BROWSER;
  else if (tests.value[0].result.name === "error" || tests.value[0].result.name === "bad") state.value = State.BAD_INTERNET;
  else state.value = State.GOOD;
}

async function restart() {
  await launchTests();
}

onMounted(async () => {
  await launchTests()
});
</script>